var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLucide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9601 36.0005L27.9601 8.00045C27.6112 7.38486 27.1053 6.87282 26.494 6.51659C25.8826 6.16035 25.1877 5.97266 24.4801 5.97266C23.7725 5.97266 23.0776 6.16035 22.4663 6.51659C21.8549 6.87282 21.349 7.38486 21.0001 8.00045L5.0001 36.0005C4.64747 36.6112 4.46256 37.3043 4.46412 38.0095C4.46568 38.7147 4.65366 39.4069 5.009 40.0161C5.36433 40.6252 5.8744 41.1296 6.48749 41.4781C7.10059 41.8266 7.79492 42.0068 8.5001 42.0005H40.5001C41.2019 41.9997 41.8912 41.8144 42.4987 41.463C43.1062 41.1116 43.6105 40.6066 43.9611 39.9987C44.3117 39.3907 44.4962 38.7012 44.496 37.9994C44.4958 37.2976 44.311 36.6082 43.9601 36.0005Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 18V26",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 34H24.52",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLucide);
export default __webpack_public_path__ + "static/media/lucide.e9dfbe2b.svg";
export { ForwardRef as ReactComponent };